import { GuidService } from 'ui-components/services/guid-service';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';
import { BulkActions } from '../../../enums/bulk-actions';

export const Confirmation = {
  id: 'confirmation',
  name: BulkActions.confirmation.message,

  makeHandler: (dispatch, bulkUpdateTypeData) => {
    return (ids, filters) =>
      dispatch(BulkUpdateActions.startBulkUpdateJob(bulkUpdateTypeData, [BulkActions.confirmation], ids, GuidService.newGuid(), filters));
  },
};
